import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 20.415a8 8 0 1 0 3 -15.415h-3","key":"svg-0"}],["path",{"d":"M13 8l-3 -3l3 -3","key":"svg-1"}],["path",{"d":"M7 17l4 -4l-4 -4l-4 4l4 4","key":"svg-2"}]]

const IconPlaceholder = createReactComponent('outline', 'placeholder', 'Placeholder', __iconNode);

export default IconPlaceholder;